<template>
  <section class="members">
    <div class="members__header">
      <div class="members__info">
        <div class="members__icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0652 12.8512 14.2174 12.5 13.3333 12.5H6.66667C5.78261 12.5 4.93476 12.8512 4.30964 13.4763C3.68452 14.1014 3.33333 14.9493 3.33333 15.8333V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 10 2.5C8.15905 2.5 6.66666 3.99238 6.66666 5.83333C6.66666 7.67428 8.15905 9.16667 10 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <h2 class="members__title">Recent Members</h2>
          <p class="members__subtitle">Members that have used your API in the last 48 hours</p>
        </div>
      </div>
    </div>
    
    <div class="members__content">
      <MembersTable
        v-if="dealroomMembers && dealroomMembers.length !== 0"
        :tableHeaders="tableHeaders"
        :tableRows="tableRows"
        :columnNumber="tableHeaders.length - 2"
        :columnWidth="200"
        :totalPage="pages"
        :currentPage="page"
        :deals="tokens"
        @gotoPage="gotoPage"
        :showPagination="true"
        @update-members="fetchDealRoomMembers({ page })"
      />
      <EmptyState v-if="!dealroomMembers || dealroomMembers.length === 0">
        <template v-slot:message>
          <div class="empty-message">
            <div class="empty-message__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.6667 28V25.3333C26.6667 23.9188 26.1048 22.5623 25.1046 21.5621C24.1044 20.5619 22.7479 20 21.3333 20H10.6667C9.25218 20 7.89562 20.5619 6.89543 21.5621C5.89524 22.5623 5.33333 23.9188 5.33333 25.3333V28" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 14.6667C18.9455 14.6667 21.3333 12.2789 21.3333 9.33333C21.3333 6.38781 18.9455 4 16 4C13.0545 4 10.6667 6.38781 10.6667 9.33333C10.6667 12.2789 13.0545 14.6667 16 14.6667Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="empty-message__title">No members yet</h3>
            <p class="empty-message__text">
              There are no members on this account. Members will appear here when they join your platform.
            </p>
          </div>
        </template>
      </EmptyState>
    </div>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import MembersTable from "@/components/tables/MembersTable";
  import EmptyState from "@/components/notification/EmptyState";
  import { formatISOTime, formatISODate, truncate } from "@/utils/helpers.js";
  export default {
    name: "Members",
    data() {
      return {
        tableHeaders: [
          "Name",
          "Email",
          "Phone",
          "Joined",
          "id",
        ],
        tableRows: [],
        page: 1,
        pages: 0,
      };
    },
    components: { MembersTable, EmptyState },
    computed: {
      ...mapGetters("TokenModule", ["dealroomMembers"]),
      ...mapGetters("organisationModule", ["tokens"]),
    },
    created() {
      this.fetchDealRoomMembers();
    },
    watch: {
      dealroomMembers: "updateTableRow",
    },
    methods: {
      ...mapActions("TokenModule", ["getDealRoomMembers"]),
      async fetchDealRoomMembers(query = { page: 1, limit: 10 }) {
        try {
          const response = await this.getDealRoomMembers(query);
          const { page, pages } = response.data.data;
          this.page = page;
          this.pages = pages;
        } catch (error) {
          return error;
        }
      },

      updateTableRow() {
        this.tableRows = this.dealroomMembers?.map((member) => {
          let name = "";
          let status = member.status;
          switch (status) {
            case "Inactive":
              status = "Deactivated";
              break;

            case "Pending_Approval":
              status = "Pending";
              break;
            default:
              break;
          }
          if (status == "Pending") {
            name = member.name;
          } else {
            name = `${member.user ? member.user.fname : member.fname} ${
              member.user ? member.user.lname : member.lname
            }`;
          }
          return {
            name: `<span class="tw-font-bold">${name}</span>`,
            email: truncate(
              member.user?.email ? member.user?.email : member.email,
              25
            ),
            phone: ` <a href="tel:+${member.user?.phone}">${
              member.user?.phone || "------"
            }</a>`,
            joined: `${formatISODate(
              member.createdAt || member.date_joined
            )}`,
            id: `data-id/${member.member_id ? member.member_id : member._id}/${
              member.user ? member.user._id : member._id
            }`,
          };
        });
      },

      gotoPage(page) {
        const query = { page: page, status: "" };
        this.fetchDealRoomMembers(query);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .members {
    padding: 32px;
    
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 20px;
      flex-wrap: wrap;
      padding-bottom: 24px;
      border-bottom: 1px solid #E2E8F0;
      margin-bottom: 24px;
    }
    
    &__info {
      display: flex;
      align-items: flex-start;
      gap: 14px;
    }
    
    &__icon {
      width: 40px;
      height: 40px;
      background: #EEF4FF;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #4D84FF;
      flex-shrink: 0;
    }
    
    &__title {
      font-family: 'DM Sans', sans-serif;
      font-size: 16px;
      font-weight: 500;
      color: #0F172A;
      margin: 0 0 4px 0;
    }
    
    &__subtitle {
      font-family: 'DM Sans', sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #64748B;
      margin: 0;
    }
    
    &__content {
      background: #ffffff;
      overflow-x: auto;
    }
  }
  
  .empty-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 48px 24px;
    
    &__icon {
      width: 64px;
      height: 64px;
      background: #F1F5F9;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #64748B;
      margin-bottom: 16px;
    }
    
    &__title {
      font-family: 'DM Sans', sans-serif;
      font-size: 16px;
      font-weight: 500;
      color: #0F172A;
      margin: 0 0 8px 0;
    }
    
    &__text {
      font-family: 'DM Sans', sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #64748B;
      margin: 0;
      max-width: 320px;
    }
  }
  
  @media (max-width: 640px) {
    .members {
      padding: 20px;
    }
  }
</style>
